/* xs-recent.js v1.1 (2026-09-15) — rename-proof "Recently viewed" for Impulse (Archetype)
   Why: the stock theme keys history by product handle and links with the stored
   (collection-prefixed) URL; after a handle change /products/<old>.js and
   /collections/x/products/<old> both 404 (Shopify's auto redirect only covers
   /products/<old>), so renamed products silently vanished or linked to 404 pages.
   What: history keeps id + canonical url and is capped; every entry is re-resolved
   on render (handle -> id via predictive search -> 301 follow); dead entries are
   dropped; cards always link to the product's CURRENT url. Nothing here throws.
   How: loaded (defer) BEFORE theme.js; theme.js registers sections synchronously
   at DOMready, so the patches are installed through property setters the moment
   theme.js assigns theme.Product / theme.RecentlyViewed. */
(function () {
  window.theme = window.theme || {};
  var MAX = 20;
  var SS_KEY = 'recent-products-v3'; /* 1007 老板会话:美国库存角标主图已换,升版本号让各浏览器的会话缓存立即失效、重新取最新主图 */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  var suggestUrl = root + 'search/suggest.json';

  function rec() {
    var rv = theme.recentlyViewed || (theme.recentlyViewed = { recent: {}, productInfo: {} });
    return rv.recent || (rv.recent = {});
  }
  function save() {
    try { if (theme.config.hasLocalStorage) window.localStorage.setItem('theme-recent', JSON.stringify(rec())); } catch (e) {}
  }
  var cache = {};
  try { cache = JSON.parse(window.sessionStorage.getItem(SS_KEY) || '{}') || {}; } catch (e) { cache = {}; }
  function saveCache() {
    try { window.sessionStorage.setItem(SS_KEY, JSON.stringify(cache)); } catch (e) {}
  }
  function canonical(url, handle) {
    url = url || (root + 'products/' + handle);
    return url.replace(/\/collections\/[^\/]+(?=\/products\/)/, '');
  }
  function handleFromUrl(u) {
    var m = String(u || '').match(/\/products\/([^\/?#]+)/);
    try { return m ? decodeURIComponent(m[1]) : null; } catch (e) { return m ? m[1] : null; }
  }

  /* --- record a view (product page / quick-shop modal) --- */
  function patchProduct(Product) {
    if (!Product || !Product.prototype) return;
    Product.prototype.addIdToRecentlyViewed = function () {
    try {
      var c = this.container;
      var handle = c.getAttribute('data-product-handle');
      if (!handle) return;
      var r = rec();
      var entry = {
        url: canonical(c.getAttribute('data-product-url'), handle),
        aspectRatio: c.getAttribute('data-aspect-ratio'),
        featuredImage: c.getAttribute('data-img-url'),
        id: c.getAttribute('data-product-id'),
        t: Date.now()
      };
      if (Object.prototype.hasOwnProperty.call(r, handle)) delete r[handle];
      r[handle] = entry;
      var keys = Object.keys(r);
      while (keys.length > MAX) delete r[keys.shift()];
      save();
    } catch (e) {}
  };
  }

  /* --- resolvers: never throw, null = not renderable --- */
  function getJson(handle) {
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (res.ok) return res.json().then(function (p) { return { status: 200, product: p }; });
        return { status: res.status, product: null };
      })
      .catch(function () { return { status: 0, product: null }; });
  }
  function byId(id) {
    if (!id) return Promise.resolve(null);
    var u = suggestUrl + (suggestUrl.indexOf('?') > -1 ? '&' : '?') + 'q=' + encodeURIComponent('id:' + id) + '&resources[type]=product&resources[limit]=1';
    return fetch(u, { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (j) {
        var p = j && j.resources && j.resources.results && j.resources.results.products && j.resources.results.products[0];
        return p && p.handle && String(p.id) === String(id) ? p.handle : null;
      })
      .catch(function () { return null; });
  }
  function byRedirect(handle) {
    return fetch(root + 'products/' + encodeURIComponent(handle), { method: 'HEAD', credentials: 'same-origin', redirect: 'follow' })
      .then(function (res) {
        if (!res.ok) return null;
        var h = handleFromUrl(res.url);
        return h && h !== handle ? h : null;
      })
      .catch(function () { return null; });
  }
  function migrate(oldKey, newHandle, product) {
    var r = rec(), out = {}, moved = false;
    Object.keys(r).forEach(function (k) {
      if (k === oldKey) {
        var e = r[k] || {};
        e.url = product && product.url ? product.url : (root + 'products/' + newHandle);
        if (product && product.id) e.id = String(product.id);
        out[newHandle] = e; moved = true;
      } else if (k !== newHandle) {
        out[k] = r[k];
      }
    });
    if (!moved) out[newHandle] = { url: root + 'products/' + newHandle, id: product && product.id ? String(product.id) : undefined, t: Date.now() };
    theme.recentlyViewed.recent = out;
    save();
  }
  function drop(key) {
    var r = rec();
    if (Object.prototype.hasOwnProperty.call(r, key)) { delete r[key]; save(); }
  }
  function resolve(key) {
    if (cache[key] && cache[key].handle) return Promise.resolve(cache[key]);
    var entry = rec()[key] || {};
    return getJson(key).then(function (a) {
      if (a.product) return a.product;
      if (a.status !== 404) return null; // transient problem: skip this render, keep the entry
      return byId(entry.id).then(function (h) { return h || byRedirect(key); }).then(function (h) {
        if (!h || h === key) { drop(key); return null; }
        return getJson(h).then(function (b) {
          if (!b.product) { if (b.status === 404) drop(key); return null; }
          migrate(key, h, b.product);
          return b.product;
        });
      });
    }).then(function (p) {
      if (p && p.handle) { cache[key] = p; saveCache(); }
      return p;
    }).catch(function () { return null; });
  }

  /* --- render --- */
  function patchRecentlyViewed(RV) {
    if (!RV || !RV.prototype) return;
    RV.prototype.decorate = function (product) {
    var r = rec();
    var e = r[product.handle] || {};
    var widths = [180, 360, 540, 720, 900];
    product.url = product.url || (root + 'products/' + product.handle); // current url, never the stored one
    product.image_responsive_url = theme.Images.buildImagePath(product.featured_image);
    product.image_responsive_urls = theme.Images.buildImagePath(product.featured_image, widths);
    var ar = parseFloat(e.aspectRatio);
    if (!ar && product.media && product.media[0] && product.media[0].aspect_ratio) ar = 100 / product.media[0].aspect_ratio;
    product.image_aspect_ratio = ar || 100;
    var v = product.variants && product.variants[0];
    if (v && v.unit_price) {
      var baseUnit = '';
      if (v.unit_price_measurement) {
        if (v.unit_price_measurement.reference_value != 1) baseUnit += v.unit_price_measurement.reference_value + ' ';
        baseUnit += v.unit_price_measurement.reference_unit;
      }
      product.unit_price = theme.Currency.formatMoney(v.unit_price);
      if (baseUnit !== '') product.unit_price += '/' + baseUnit;
    }
    return product;
  };

    RV.prototype.init = function () {
    if (this._xsInit) return;
    this._xsInit = true;
    var self = this;
    try {
      var keys = Object.keys(rec()).filter(function (k) { return k && k !== 'undefined' && k !== 'null'; });
      if (!keys.length) { this.container.classList.add('hide'); return; }
      this.outputContainer = document.getElementById('RecentlyViewed-' + this.sectionId);
      this.handle = this.container.getAttribute('data-product-handle');
      var limit = parseInt(this.container.getAttribute('data-recent-count'), 10) || 5;
      var wanted = keys.reverse().filter(function (k) { return k !== self.handle; }).slice(0, limit + 3);
      if (!wanted.length || !this.outputContainer) { this.container.classList.add('hide'); return; }
      Promise.all(wanted.map(resolve)).then(function (results) {
        var seen = {};
        var products = results.filter(function (p) {
          if (!p || !p.handle || p.handle === self.handle || seen[p.handle]) return false;
          seen[p.handle] = true; return true;
        }).slice(0, limit);
        if (!products.length) { self.container.classList.add('hide'); return; }
        self.outputContainer.innerHTML = theme.buildProductGridItem(products.map(function (p) { return self.decorate(p); }), self.gridItemWidth, self.rowOf, self.imageSizes);
        self.container.classList.remove('hide');
        if (window.AOS) AOS.refreshHard();
      }).catch(function () { self.container.classList.add('hide'); });
    } catch (e) { try { this.container.classList.add('hide'); } catch (e2) {} }
  };
    RV.prototype.onUnload = function () { this._xsInit = false; };
  }

  /* --- install: patch when theme.js assigns the constructors (or now, if already there) --- */
  function trap(name, patch) {
    var cur = theme[name];
    if (cur) { patch(cur); return; }
    try {
      Object.defineProperty(theme, name, {
        configurable: true, enumerable: true,
        get: function () { return cur; },
        set: function (v) { cur = v; try { patch(v); } catch (e) {} }
      });
    } catch (e) {}
  }
  trap('Product', patchProduct);
  trap('RecentlyViewed', patchRecentlyViewed);
  window.xsRecent = { version: '1.1', resolve: resolve, canonical: canonical };
})();
